
// @ts-nocheck


export const localeCodes =  [
  "au",
  "de",
  "de-en",
  "en",
  "es",
  "mx",
  "fr",
  "it",
  "jp",
  "ru",
  "sg",
  "uk"
]

export const localeLoaders = {
  "au": [{ key: "../lang/au/common/header.ts", load: () => import("../lang/au/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_header_ts" */), cache: true },
{ key: "../lang/au/common/footer.ts", load: () => import("../lang/au/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_footer_ts" */), cache: true },
{ key: "../lang/au/common/addCartPopup.ts", load: () => import("../lang/au/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/au/common/ContactSales.ts", load: () => import("../lang/au/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_ContactSales_ts" */), cache: true },
{ key: "../lang/au/common/error.ts", load: () => import("../lang/au/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_error_ts" */), cache: true },
{ key: "../lang/au/common/cookieTip.ts", load: () => import("../lang/au/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_cookieTip_ts" */), cache: true },
{ key: "../lang/au/common/telCode.ts", load: () => import("../lang/au/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_telCode_ts" */), cache: true },
{ key: "../lang/au/common/SelectCountry.ts", load: () => import("../lang/au/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/au/common/formValidate.ts", load: () => import("../lang/au/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_formValidate_ts" */), cache: true },
{ key: "../lang/au/common/contactUs.ts", load: () => import("../lang/au/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_common_contactUs_ts" */), cache: true },
{ key: "../lang/au/basic/home.ts", load: () => import("../lang/au/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_home_ts" */), cache: true },
{ key: "../lang/au/basic/firstCategory.ts", load: () => import("../lang/au/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/au/basic/secondCategory.ts", load: () => import("../lang/au/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/au/basic/caseStudy.ts", load: () => import("../lang/au/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/au/basic/blog.ts", load: () => import("../lang/au/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_blog_ts" */), cache: true },
{ key: "../lang/au/basic/media.ts", load: () => import("../lang/au/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_basic_media_ts" */), cache: true },
{ key: "../lang/au/account/checkout.ts", load: () => import("../lang/au/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_account_checkout_ts" */), cache: true },
{ key: "../lang/au/account/checkoutAgainst.ts", load: () => import("../lang/au/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/au/account/pay.ts", load: () => import("../lang/au/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_account_pay_ts" */), cache: true },
{ key: "../lang/au/support/contactSales.ts", load: () => import("../lang/au/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_contactSales_ts" */), cache: true },
{ key: "../lang/au/support/requestTechSupport.ts", load: () => import("../lang/au/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/au/support/technicalDocuments.ts", load: () => import("../lang/au/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/au/support/mtpDensity.ts", load: () => import("../lang/au/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/au/support/picOSVUserGuide.ts", load: () => import("../lang/au/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/au/support/fmtSeries.ts", load: () => import("../lang/au/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/au/support/SiteMap.ts", load: () => import("../lang/au/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_SiteMap_ts" */), cache: true },
{ key: "../lang/au/support/solutionDemoTest.ts", load: () => import("../lang/au/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/au/support/queryTools.ts", load: () => import("../lang/au/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_queryTools_ts" */), cache: true },
{ key: "../lang/au/support/solutionDemoTest.ts", load: () => import("../lang/au/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/au/support/rmaChecklist.ts", load: () => import("../lang/au/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/au/support/testSupport.ts", load: () => import("../lang/au/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_testSupport_ts" */), cache: true },
{ key: "../lang/au/support/solutionServices.ts", load: () => import("../lang/au/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_support_solutionServices_ts" */), cache: true },
{ key: "../lang/au/popup/address.ts", load: () => import("../lang/au/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_au_popup_address_ts" */), cache: true }],
  "de": [{ key: "../lang/de/common/header.ts", load: () => import("../lang/de/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_header_ts" */), cache: true },
{ key: "../lang/de/common/footer.ts", load: () => import("../lang/de/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_footer_ts" */), cache: true },
{ key: "../lang/de/common/addCartPopup.ts", load: () => import("../lang/de/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/de/common/ContactSales.ts", load: () => import("../lang/de/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_ContactSales_ts" */), cache: true },
{ key: "../lang/de/common/error.ts", load: () => import("../lang/de/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_error_ts" */), cache: true },
{ key: "../lang/de/common/cookieTip.ts", load: () => import("../lang/de/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_cookieTip_ts" */), cache: true },
{ key: "../lang/de/common/telCode.ts", load: () => import("../lang/de/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_telCode_ts" */), cache: true },
{ key: "../lang/de/common/SelectCountry.ts", load: () => import("../lang/de/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/de/common/formValidate.ts", load: () => import("../lang/de/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_formValidate_ts" */), cache: true },
{ key: "../lang/de/common/contactUs.ts", load: () => import("../lang/de/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_common_contactUs_ts" */), cache: true },
{ key: "../lang/de/basic/home.ts", load: () => import("../lang/de/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_home_ts" */), cache: true },
{ key: "../lang/de/basic/firstCategory.ts", load: () => import("../lang/de/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/de/basic/secondCategory.ts", load: () => import("../lang/de/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/de/basic/caseStudy.ts", load: () => import("../lang/de/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/de/basic/blog.ts", load: () => import("../lang/de/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_blog_ts" */), cache: true },
{ key: "../lang/de/basic/media.ts", load: () => import("../lang/de/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_basic_media_ts" */), cache: true },
{ key: "../lang/de/account/checkout.ts", load: () => import("../lang/de/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_account_checkout_ts" */), cache: true },
{ key: "../lang/de/account/checkoutAgainst.ts", load: () => import("../lang/de/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/de/account/pay.ts", load: () => import("../lang/de/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_account_pay_ts" */), cache: true },
{ key: "../lang/de/support/contactSales.ts", load: () => import("../lang/de/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_contactSales_ts" */), cache: true },
{ key: "../lang/de/support/requestTechSupport.ts", load: () => import("../lang/de/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/de/support/technicalDocuments.ts", load: () => import("../lang/de/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/de/support/mtpDensity.ts", load: () => import("../lang/de/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/de/support/picOSVUserGuide.ts", load: () => import("../lang/de/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/de/support/fmtSeries.ts", load: () => import("../lang/de/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/de/support/SiteMap.ts", load: () => import("../lang/de/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_SiteMap_ts" */), cache: true },
{ key: "../lang/de/support/solutionDemoTest.ts", load: () => import("../lang/de/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/de/support/queryTools.ts", load: () => import("../lang/de/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_queryTools_ts" */), cache: true },
{ key: "../lang/de/support/solutionDemoTest.ts", load: () => import("../lang/de/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/de/support/rmaChecklist.ts", load: () => import("../lang/de/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/de/support/testSupport.ts", load: () => import("../lang/de/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_testSupport_ts" */), cache: true },
{ key: "../lang/de/support/solutionServices.ts", load: () => import("../lang/de/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_support_solutionServices_ts" */), cache: true },
{ key: "../lang/de/popup/address.ts", load: () => import("../lang/de/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_popup_address_ts" */), cache: true }],
  "de-en": [{ key: "../lang/de-en/common/header.ts", load: () => import("../lang/de-en/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_header_ts" */), cache: true },
{ key: "../lang/de-en/common/footer.ts", load: () => import("../lang/de-en/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_footer_ts" */), cache: true },
{ key: "../lang/de-en/common/addCartPopup.ts", load: () => import("../lang/de-en/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/de-en/common/ContactSales.ts", load: () => import("../lang/de-en/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_ContactSales_ts" */), cache: true },
{ key: "../lang/de-en/common/error.ts", load: () => import("../lang/de-en/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_error_ts" */), cache: true },
{ key: "../lang/de-en/common/cookieTip.ts", load: () => import("../lang/de-en/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_cookieTip_ts" */), cache: true },
{ key: "../lang/de-en/common/telCode.ts", load: () => import("../lang/de-en/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_telCode_ts" */), cache: true },
{ key: "../lang/de-en/common/SelectCountry.ts", load: () => import("../lang/de-en/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/de-en/common/formValidate.ts", load: () => import("../lang/de-en/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_formValidate_ts" */), cache: true },
{ key: "../lang/de-en/common/contactUs.ts", load: () => import("../lang/de-en/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_common_contactUs_ts" */), cache: true },
{ key: "../lang/de-en/basic/home.ts", load: () => import("../lang/de-en/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_home_ts" */), cache: true },
{ key: "../lang/de-en/basic/firstCategory.ts", load: () => import("../lang/de-en/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/de-en/basic/secondCategory.ts", load: () => import("../lang/de-en/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/de-en/basic/caseStudy.ts", load: () => import("../lang/de-en/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/de-en/basic/blog.ts", load: () => import("../lang/de-en/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_blog_ts" */), cache: true },
{ key: "../lang/de-en/basic/media.ts", load: () => import("../lang/de-en/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_basic_media_ts" */), cache: true },
{ key: "../lang/de-en/account/checkout.ts", load: () => import("../lang/de-en/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_account_checkout_ts" */), cache: true },
{ key: "../lang/de-en/account/checkoutAgainst.ts", load: () => import("../lang/de-en/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/de-en/account/pay.ts", load: () => import("../lang/de-en/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_account_pay_ts" */), cache: true },
{ key: "../lang/de-en/support/contactSales.ts", load: () => import("../lang/de-en/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_contactSales_ts" */), cache: true },
{ key: "../lang/de-en/support/requestTechSupport.ts", load: () => import("../lang/de-en/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/de-en/support/technicalDocuments.ts", load: () => import("../lang/de-en/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/de-en/support/mtpDensity.ts", load: () => import("../lang/de-en/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/de-en/support/picOSVUserGuide.ts", load: () => import("../lang/de-en/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/de-en/support/fmtSeries.ts", load: () => import("../lang/de-en/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/de-en/support/SiteMap.ts", load: () => import("../lang/de-en/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_SiteMap_ts" */), cache: true },
{ key: "../lang/de-en/support/solutionDemoTest.ts", load: () => import("../lang/de-en/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/de-en/support/queryTools.ts", load: () => import("../lang/de-en/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_queryTools_ts" */), cache: true },
{ key: "../lang/de-en/support/solutionDemoTest.ts", load: () => import("../lang/de-en/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/de-en/support/rmaChecklist.ts", load: () => import("../lang/de-en/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/de-en/support/testSupport.ts", load: () => import("../lang/de-en/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_testSupport_ts" */), cache: true },
{ key: "../lang/de-en/support/solutionServices.ts", load: () => import("../lang/de-en/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_support_solutionServices_ts" */), cache: true },
{ key: "../lang/de-en/popup/address.ts", load: () => import("../lang/de-en/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_de_en_popup_address_ts" */), cache: true }],
  "en": [{ key: "../lang/en/common/header.ts", load: () => import("../lang/en/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_header_ts" */), cache: true },
{ key: "../lang/en/common/footer.ts", load: () => import("../lang/en/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_footer_ts" */), cache: true },
{ key: "../lang/en/common/addCartPopup.ts", load: () => import("../lang/en/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/en/common/ContactSales.ts", load: () => import("../lang/en/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_ContactSales_ts" */), cache: true },
{ key: "../lang/en/common/error.ts", load: () => import("../lang/en/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_error_ts" */), cache: true },
{ key: "../lang/en/common/cookieTip.ts", load: () => import("../lang/en/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_cookieTip_ts" */), cache: true },
{ key: "../lang/en/common/telCode.ts", load: () => import("../lang/en/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_telCode_ts" */), cache: true },
{ key: "../lang/en/common/SelectCountry.ts", load: () => import("../lang/en/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/en/common/formValidate.ts", load: () => import("../lang/en/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_formValidate_ts" */), cache: true },
{ key: "../lang/en/common/contactUs.ts", load: () => import("../lang/en/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_common_contactUs_ts" */), cache: true },
{ key: "../lang/en/basic/home.ts", load: () => import("../lang/en/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_home_ts" */), cache: true },
{ key: "../lang/en/basic/firstCategory.ts", load: () => import("../lang/en/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/en/basic/secondCategory.ts", load: () => import("../lang/en/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/en/basic/caseStudy.ts", load: () => import("../lang/en/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/en/basic/blog.ts", load: () => import("../lang/en/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_blog_ts" */), cache: true },
{ key: "../lang/en/basic/media.ts", load: () => import("../lang/en/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_basic_media_ts" */), cache: true },
{ key: "../lang/en/account/checkout.ts", load: () => import("../lang/en/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_account_checkout_ts" */), cache: true },
{ key: "../lang/en/account/checkoutAgainst.ts", load: () => import("../lang/en/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/en/account/pay.ts", load: () => import("../lang/en/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_account_pay_ts" */), cache: true },
{ key: "../lang/en/support/contactSales.ts", load: () => import("../lang/en/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_contactSales_ts" */), cache: true },
{ key: "../lang/en/support/requestTechSupport.ts", load: () => import("../lang/en/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/en/support/technicalDocuments.ts", load: () => import("../lang/en/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/en/support/mtpDensity.ts", load: () => import("../lang/en/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/en/support/picOSVUserGuide.ts", load: () => import("../lang/en/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/en/support/fmtSeries.ts", load: () => import("../lang/en/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/en/support/SiteMap.ts", load: () => import("../lang/en/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_SiteMap_ts" */), cache: true },
{ key: "../lang/en/support/solutionDemoTest.ts", load: () => import("../lang/en/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/en/support/queryTools.ts", load: () => import("../lang/en/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_queryTools_ts" */), cache: true },
{ key: "../lang/en/support/solutionDemoTest.ts", load: () => import("../lang/en/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/en/support/rmaChecklist.ts", load: () => import("../lang/en/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/en/support/testSupport.ts", load: () => import("../lang/en/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_testSupport_ts" */), cache: true },
{ key: "../lang/en/support/solutionServices.ts", load: () => import("../lang/en/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_support_solutionServices_ts" */), cache: true },
{ key: "../lang/en/popup/address.ts", load: () => import("../lang/en/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_en_popup_address_ts" */), cache: true }],
  "es": [{ key: "../lang/es/common/header.ts", load: () => import("../lang/es/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_header_ts" */), cache: true },
{ key: "../lang/es/common/footer.ts", load: () => import("../lang/es/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_footer_ts" */), cache: true },
{ key: "../lang/es/common/addCartPopup.ts", load: () => import("../lang/es/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/es/common/ContactSales.ts", load: () => import("../lang/es/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_ContactSales_ts" */), cache: true },
{ key: "../lang/es/common/error.ts", load: () => import("../lang/es/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_error_ts" */), cache: true },
{ key: "../lang/es/common/cookieTip.ts", load: () => import("../lang/es/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_cookieTip_ts" */), cache: true },
{ key: "../lang/es/common/telCode.ts", load: () => import("../lang/es/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_telCode_ts" */), cache: true },
{ key: "../lang/es/common/SelectCountry.ts", load: () => import("../lang/es/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/es/common/formValidate.ts", load: () => import("../lang/es/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_formValidate_ts" */), cache: true },
{ key: "../lang/es/common/contactUs.ts", load: () => import("../lang/es/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_contactUs_ts" */), cache: true },
{ key: "../lang/es/basic/home.ts", load: () => import("../lang/es/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_home_ts" */), cache: true },
{ key: "../lang/es/basic/firstCategory.ts", load: () => import("../lang/es/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/es/basic/secondCategory.ts", load: () => import("../lang/es/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/es/basic/caseStudy.ts", load: () => import("../lang/es/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/es/basic/blog.ts", load: () => import("../lang/es/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_blog_ts" */), cache: true },
{ key: "../lang/es/basic/media.ts", load: () => import("../lang/es/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_media_ts" */), cache: true },
{ key: "../lang/es/account/checkout.ts", load: () => import("../lang/es/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_checkout_ts" */), cache: true },
{ key: "../lang/es/account/checkoutAgainst.ts", load: () => import("../lang/es/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/es/account/pay.ts", load: () => import("../lang/es/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_pay_ts" */), cache: true },
{ key: "../lang/es/support/contactSales.ts", load: () => import("../lang/es/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_contactSales_ts" */), cache: true },
{ key: "../lang/es/support/requestTechSupport.ts", load: () => import("../lang/es/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/es/support/technicalDocuments.ts", load: () => import("../lang/es/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/es/support/mtpDensity.ts", load: () => import("../lang/es/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/es/support/picOSVUserGuide.ts", load: () => import("../lang/es/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/es/support/fmtSeries.ts", load: () => import("../lang/es/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/es/support/SiteMap.ts", load: () => import("../lang/es/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_SiteMap_ts" */), cache: true },
{ key: "../lang/es/support/solutionDemoTest.ts", load: () => import("../lang/es/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/es/support/queryTools.ts", load: () => import("../lang/es/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_queryTools_ts" */), cache: true },
{ key: "../lang/es/support/solutionDemoTest.ts", load: () => import("../lang/es/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/es/support/rmaChecklist.ts", load: () => import("../lang/es/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/es/support/testSupport.ts", load: () => import("../lang/es/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_testSupport_ts" */), cache: true },
{ key: "../lang/es/support/solutionServices.ts", load: () => import("../lang/es/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionServices_ts" */), cache: true },
{ key: "../lang/es/popup/address.ts", load: () => import("../lang/es/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_popup_address_ts" */), cache: true }],
  "mx": [{ key: "../lang/es/common/header.ts", load: () => import("../lang/es/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_header_ts" */), cache: true },
{ key: "../lang/es/common/footer.ts", load: () => import("../lang/es/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_footer_ts" */), cache: true },
{ key: "../lang/es/common/addCartPopup.ts", load: () => import("../lang/es/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/es/common/ContactSales.ts", load: () => import("../lang/es/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_ContactSales_ts" */), cache: true },
{ key: "../lang/es/common/error.ts", load: () => import("../lang/es/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_error_ts" */), cache: true },
{ key: "../lang/es/common/cookieTip.ts", load: () => import("../lang/es/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_cookieTip_ts" */), cache: true },
{ key: "../lang/es/common/telCode.ts", load: () => import("../lang/es/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_telCode_ts" */), cache: true },
{ key: "../lang/es/common/SelectCountry.ts", load: () => import("../lang/es/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/es/common/formValidate.ts", load: () => import("../lang/es/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_formValidate_ts" */), cache: true },
{ key: "../lang/es/common/contactUs.ts", load: () => import("../lang/es/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_common_contactUs_ts" */), cache: true },
{ key: "../lang/es/basic/home.ts", load: () => import("../lang/es/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_home_ts" */), cache: true },
{ key: "../lang/es/basic/firstCategory.ts", load: () => import("../lang/es/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/es/basic/secondCategory.ts", load: () => import("../lang/es/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/es/basic/caseStudy.ts", load: () => import("../lang/es/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/es/basic/blog.ts", load: () => import("../lang/es/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_blog_ts" */), cache: true },
{ key: "../lang/es/basic/media.ts", load: () => import("../lang/es/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_basic_media_ts" */), cache: true },
{ key: "../lang/es/account/checkout.ts", load: () => import("../lang/es/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_checkout_ts" */), cache: true },
{ key: "../lang/es/account/checkoutAgainst.ts", load: () => import("../lang/es/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/es/account/pay.ts", load: () => import("../lang/es/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_account_pay_ts" */), cache: true },
{ key: "../lang/es/support/contactSales.ts", load: () => import("../lang/es/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_contactSales_ts" */), cache: true },
{ key: "../lang/es/support/requestTechSupport.ts", load: () => import("../lang/es/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/es/support/technicalDocuments.ts", load: () => import("../lang/es/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/es/support/mtpDensity.ts", load: () => import("../lang/es/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/es/support/picOSVUserGuide.ts", load: () => import("../lang/es/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/es/support/fmtSeries.ts", load: () => import("../lang/es/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/es/support/SiteMap.ts", load: () => import("../lang/es/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_SiteMap_ts" */), cache: true },
{ key: "../lang/es/support/solutionDemoTest.ts", load: () => import("../lang/es/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/es/support/queryTools.ts", load: () => import("../lang/es/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_queryTools_ts" */), cache: true },
{ key: "../lang/es/support/solutionDemoTest.ts", load: () => import("../lang/es/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/es/support/rmaChecklist.ts", load: () => import("../lang/es/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/es/support/testSupport.ts", load: () => import("../lang/es/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_testSupport_ts" */), cache: true },
{ key: "../lang/es/support/solutionServices.ts", load: () => import("../lang/es/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_support_solutionServices_ts" */), cache: true },
{ key: "../lang/es/popup/address.ts", load: () => import("../lang/es/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_es_popup_address_ts" */), cache: true }],
  "fr": [{ key: "../lang/fr/common/header.ts", load: () => import("../lang/fr/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_header_ts" */), cache: true },
{ key: "../lang/fr/common/footer.ts", load: () => import("../lang/fr/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_footer_ts" */), cache: true },
{ key: "../lang/fr/common/addCartPopup.ts", load: () => import("../lang/fr/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/fr/common/ContactSales.ts", load: () => import("../lang/fr/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_ContactSales_ts" */), cache: true },
{ key: "../lang/fr/common/error.ts", load: () => import("../lang/fr/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_error_ts" */), cache: true },
{ key: "../lang/fr/common/cookieTip.ts", load: () => import("../lang/fr/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_cookieTip_ts" */), cache: true },
{ key: "../lang/fr/common/telCode.ts", load: () => import("../lang/fr/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_telCode_ts" */), cache: true },
{ key: "../lang/fr/common/SelectCountry.ts", load: () => import("../lang/fr/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/fr/common/formValidate.ts", load: () => import("../lang/fr/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_formValidate_ts" */), cache: true },
{ key: "../lang/fr/common/contactUs.ts", load: () => import("../lang/fr/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_common_contactUs_ts" */), cache: true },
{ key: "../lang/fr/basic/home.ts", load: () => import("../lang/fr/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_home_ts" */), cache: true },
{ key: "../lang/fr/basic/firstCategory.ts", load: () => import("../lang/fr/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/fr/basic/secondCategory.ts", load: () => import("../lang/fr/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/fr/basic/caseStudy.ts", load: () => import("../lang/fr/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/fr/basic/blog.ts", load: () => import("../lang/fr/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_blog_ts" */), cache: true },
{ key: "../lang/fr/basic/media.ts", load: () => import("../lang/fr/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_basic_media_ts" */), cache: true },
{ key: "../lang/fr/account/checkout.ts", load: () => import("../lang/fr/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_account_checkout_ts" */), cache: true },
{ key: "../lang/fr/account/checkoutAgainst.ts", load: () => import("../lang/fr/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/fr/account/pay.ts", load: () => import("../lang/fr/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_account_pay_ts" */), cache: true },
{ key: "../lang/fr/support/contactSales.ts", load: () => import("../lang/fr/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_contactSales_ts" */), cache: true },
{ key: "../lang/fr/support/requestTechSupport.ts", load: () => import("../lang/fr/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/fr/support/technicalDocuments.ts", load: () => import("../lang/fr/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/fr/support/mtpDensity.ts", load: () => import("../lang/fr/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/fr/support/picOSVUserGuide.ts", load: () => import("../lang/fr/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/fr/support/fmtSeries.ts", load: () => import("../lang/fr/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/fr/support/SiteMap.ts", load: () => import("../lang/fr/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_SiteMap_ts" */), cache: true },
{ key: "../lang/fr/support/solutionDemoTest.ts", load: () => import("../lang/fr/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/fr/support/queryTools.ts", load: () => import("../lang/fr/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_queryTools_ts" */), cache: true },
{ key: "../lang/fr/support/solutionDemoTest.ts", load: () => import("../lang/fr/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/fr/support/rmaChecklist.ts", load: () => import("../lang/fr/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/fr/support/testSupport.ts", load: () => import("../lang/fr/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_testSupport_ts" */), cache: true },
{ key: "../lang/fr/support/solutionServices.ts", load: () => import("../lang/fr/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_support_solutionServices_ts" */), cache: true },
{ key: "../lang/fr/popup/address.ts", load: () => import("../lang/fr/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_fr_popup_address_ts" */), cache: true }],
  "it": [{ key: "../lang/it/common/header.ts", load: () => import("../lang/it/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_header_ts" */), cache: true },
{ key: "../lang/it/common/footer.ts", load: () => import("../lang/it/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_footer_ts" */), cache: true },
{ key: "../lang/it/common/addCartPopup.ts", load: () => import("../lang/it/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/it/common/ContactSales.ts", load: () => import("../lang/it/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_ContactSales_ts" */), cache: true },
{ key: "../lang/it/common/error.ts", load: () => import("../lang/it/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_error_ts" */), cache: true },
{ key: "../lang/it/common/cookieTip.ts", load: () => import("../lang/it/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_cookieTip_ts" */), cache: true },
{ key: "../lang/it/common/telCode.ts", load: () => import("../lang/it/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_telCode_ts" */), cache: true },
{ key: "../lang/it/common/SelectCountry.ts", load: () => import("../lang/it/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/it/common/formValidate.ts", load: () => import("../lang/it/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_formValidate_ts" */), cache: true },
{ key: "../lang/it/common/contactUs.ts", load: () => import("../lang/it/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_common_contactUs_ts" */), cache: true },
{ key: "../lang/it/basic/home.ts", load: () => import("../lang/it/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_home_ts" */), cache: true },
{ key: "../lang/it/basic/firstCategory.ts", load: () => import("../lang/it/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/it/basic/secondCategory.ts", load: () => import("../lang/it/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/it/basic/caseStudy.ts", load: () => import("../lang/it/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/it/basic/blog.ts", load: () => import("../lang/it/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_blog_ts" */), cache: true },
{ key: "../lang/it/basic/media.ts", load: () => import("../lang/it/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_basic_media_ts" */), cache: true },
{ key: "../lang/it/account/checkout.ts", load: () => import("../lang/it/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_account_checkout_ts" */), cache: true },
{ key: "../lang/it/account/checkoutAgainst.ts", load: () => import("../lang/it/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/it/account/pay.ts", load: () => import("../lang/it/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_account_pay_ts" */), cache: true },
{ key: "../lang/it/support/contactSales.ts", load: () => import("../lang/it/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_contactSales_ts" */), cache: true },
{ key: "../lang/it/support/requestTechSupport.ts", load: () => import("../lang/it/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/it/support/technicalDocuments.ts", load: () => import("../lang/it/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/it/support/mtpDensity.ts", load: () => import("../lang/it/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/it/support/picOSVUserGuide.ts", load: () => import("../lang/it/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/it/support/fmtSeries.ts", load: () => import("../lang/it/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/it/support/SiteMap.ts", load: () => import("../lang/it/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_SiteMap_ts" */), cache: true },
{ key: "../lang/it/support/solutionDemoTest.ts", load: () => import("../lang/it/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/it/support/queryTools.ts", load: () => import("../lang/it/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_queryTools_ts" */), cache: true },
{ key: "../lang/it/support/solutionDemoTest.ts", load: () => import("../lang/it/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/it/support/rmaChecklist.ts", load: () => import("../lang/it/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/it/support/testSupport.ts", load: () => import("../lang/it/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_testSupport_ts" */), cache: true },
{ key: "../lang/it/support/solutionServices.ts", load: () => import("../lang/it/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_support_solutionServices_ts" */), cache: true },
{ key: "../lang/it/popup/address.ts", load: () => import("../lang/it/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_it_popup_address_ts" */), cache: true }],
  "jp": [{ key: "../lang/jp/common/header.ts", load: () => import("../lang/jp/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_header_ts" */), cache: true },
{ key: "../lang/jp/common/footer.ts", load: () => import("../lang/jp/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_footer_ts" */), cache: true },
{ key: "../lang/jp/common/addCartPopup.ts", load: () => import("../lang/jp/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/jp/common/ContactSales.ts", load: () => import("../lang/jp/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_ContactSales_ts" */), cache: true },
{ key: "../lang/jp/common/error.ts", load: () => import("../lang/jp/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_error_ts" */), cache: true },
{ key: "../lang/jp/common/cookieTip.ts", load: () => import("../lang/jp/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_cookieTip_ts" */), cache: true },
{ key: "../lang/jp/common/telCode.ts", load: () => import("../lang/jp/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_telCode_ts" */), cache: true },
{ key: "../lang/jp/common/SelectCountry.ts", load: () => import("../lang/jp/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/jp/common/formValidate.ts", load: () => import("../lang/jp/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_formValidate_ts" */), cache: true },
{ key: "../lang/jp/common/contactUs.ts", load: () => import("../lang/jp/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_common_contactUs_ts" */), cache: true },
{ key: "../lang/jp/basic/home.ts", load: () => import("../lang/jp/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_home_ts" */), cache: true },
{ key: "../lang/jp/basic/firstCategory.ts", load: () => import("../lang/jp/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/jp/basic/secondCategory.ts", load: () => import("../lang/jp/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/jp/basic/caseStudy.ts", load: () => import("../lang/jp/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/jp/basic/blog.ts", load: () => import("../lang/jp/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_blog_ts" */), cache: true },
{ key: "../lang/jp/basic/media.ts", load: () => import("../lang/jp/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_basic_media_ts" */), cache: true },
{ key: "../lang/jp/account/checkout.ts", load: () => import("../lang/jp/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_account_checkout_ts" */), cache: true },
{ key: "../lang/jp/account/checkoutAgainst.ts", load: () => import("../lang/jp/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/jp/account/pay.ts", load: () => import("../lang/jp/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_account_pay_ts" */), cache: true },
{ key: "../lang/jp/support/contactSales.ts", load: () => import("../lang/jp/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_contactSales_ts" */), cache: true },
{ key: "../lang/jp/support/requestTechSupport.ts", load: () => import("../lang/jp/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/jp/support/technicalDocuments.ts", load: () => import("../lang/jp/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/jp/support/mtpDensity.ts", load: () => import("../lang/jp/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/jp/support/picOSVUserGuide.ts", load: () => import("../lang/jp/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/jp/support/fmtSeries.ts", load: () => import("../lang/jp/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/jp/support/SiteMap.ts", load: () => import("../lang/jp/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_SiteMap_ts" */), cache: true },
{ key: "../lang/jp/support/solutionDemoTest.ts", load: () => import("../lang/jp/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/jp/support/queryTools.ts", load: () => import("../lang/jp/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_queryTools_ts" */), cache: true },
{ key: "../lang/jp/support/solutionDemoTest.ts", load: () => import("../lang/jp/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/jp/support/rmaChecklist.ts", load: () => import("../lang/jp/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/jp/support/testSupport.ts", load: () => import("../lang/jp/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_testSupport_ts" */), cache: true },
{ key: "../lang/jp/support/solutionServices.ts", load: () => import("../lang/jp/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_support_solutionServices_ts" */), cache: true },
{ key: "../lang/jp/popup/address.ts", load: () => import("../lang/jp/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_jp_popup_address_ts" */), cache: true }],
  "ru": [{ key: "../lang/ru/common/header.ts", load: () => import("../lang/ru/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_header_ts" */), cache: true },
{ key: "../lang/ru/common/footer.ts", load: () => import("../lang/ru/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_footer_ts" */), cache: true },
{ key: "../lang/ru/common/addCartPopup.ts", load: () => import("../lang/ru/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/ru/common/ContactSales.ts", load: () => import("../lang/ru/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_ContactSales_ts" */), cache: true },
{ key: "../lang/ru/common/error.ts", load: () => import("../lang/ru/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_error_ts" */), cache: true },
{ key: "../lang/ru/common/cookieTip.ts", load: () => import("../lang/ru/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_cookieTip_ts" */), cache: true },
{ key: "../lang/ru/common/telCode.ts", load: () => import("../lang/ru/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_telCode_ts" */), cache: true },
{ key: "../lang/ru/common/SelectCountry.ts", load: () => import("../lang/ru/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/ru/common/formValidate.ts", load: () => import("../lang/ru/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_formValidate_ts" */), cache: true },
{ key: "../lang/ru/common/contactUs.ts", load: () => import("../lang/ru/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_common_contactUs_ts" */), cache: true },
{ key: "../lang/ru/basic/home.ts", load: () => import("../lang/ru/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_home_ts" */), cache: true },
{ key: "../lang/ru/basic/firstCategory.ts", load: () => import("../lang/ru/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/ru/basic/secondCategory.ts", load: () => import("../lang/ru/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/ru/basic/caseStudy.ts", load: () => import("../lang/ru/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/ru/basic/blog.ts", load: () => import("../lang/ru/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_blog_ts" */), cache: true },
{ key: "../lang/ru/basic/media.ts", load: () => import("../lang/ru/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_basic_media_ts" */), cache: true },
{ key: "../lang/ru/account/checkout.ts", load: () => import("../lang/ru/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_account_checkout_ts" */), cache: true },
{ key: "../lang/ru/account/checkoutAgainst.ts", load: () => import("../lang/ru/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/ru/account/pay.ts", load: () => import("../lang/ru/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_account_pay_ts" */), cache: true },
{ key: "../lang/ru/support/contactSales.ts", load: () => import("../lang/ru/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_contactSales_ts" */), cache: true },
{ key: "../lang/ru/support/requestTechSupport.ts", load: () => import("../lang/ru/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/ru/support/technicalDocuments.ts", load: () => import("../lang/ru/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/ru/support/mtpDensity.ts", load: () => import("../lang/ru/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/ru/support/picOSVUserGuide.ts", load: () => import("../lang/ru/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/ru/support/fmtSeries.ts", load: () => import("../lang/ru/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/ru/support/SiteMap.ts", load: () => import("../lang/ru/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_SiteMap_ts" */), cache: true },
{ key: "../lang/ru/support/solutionDemoTest.ts", load: () => import("../lang/ru/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/ru/support/queryTools.ts", load: () => import("../lang/ru/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_queryTools_ts" */), cache: true },
{ key: "../lang/ru/support/solutionDemoTest.ts", load: () => import("../lang/ru/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/ru/support/rmaChecklist.ts", load: () => import("../lang/ru/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/ru/support/testSupport.ts", load: () => import("../lang/ru/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_testSupport_ts" */), cache: true },
{ key: "../lang/ru/support/solutionServices.ts", load: () => import("../lang/ru/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_support_solutionServices_ts" */), cache: true },
{ key: "../lang/ru/popup/address.ts", load: () => import("../lang/ru/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_ru_popup_address_ts" */), cache: true }],
  "sg": [{ key: "../lang/sg/common/header.ts", load: () => import("../lang/sg/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_header_ts" */), cache: true },
{ key: "../lang/sg/common/footer.ts", load: () => import("../lang/sg/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_footer_ts" */), cache: true },
{ key: "../lang/sg/common/addCartPopup.ts", load: () => import("../lang/sg/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/sg/common/ContactSales.ts", load: () => import("../lang/sg/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_ContactSales_ts" */), cache: true },
{ key: "../lang/sg/common/error.ts", load: () => import("../lang/sg/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_error_ts" */), cache: true },
{ key: "../lang/sg/common/cookieTip.ts", load: () => import("../lang/sg/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_cookieTip_ts" */), cache: true },
{ key: "../lang/sg/common/telCode.ts", load: () => import("../lang/sg/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_telCode_ts" */), cache: true },
{ key: "../lang/sg/common/SelectCountry.ts", load: () => import("../lang/sg/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/sg/common/formValidate.ts", load: () => import("../lang/sg/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_formValidate_ts" */), cache: true },
{ key: "../lang/sg/common/contactUs.ts", load: () => import("../lang/sg/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_common_contactUs_ts" */), cache: true },
{ key: "../lang/sg/basic/home.ts", load: () => import("../lang/sg/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_home_ts" */), cache: true },
{ key: "../lang/sg/basic/firstCategory.ts", load: () => import("../lang/sg/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/sg/basic/secondCategory.ts", load: () => import("../lang/sg/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/sg/basic/caseStudy.ts", load: () => import("../lang/sg/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/sg/basic/blog.ts", load: () => import("../lang/sg/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_blog_ts" */), cache: true },
{ key: "../lang/sg/basic/media.ts", load: () => import("../lang/sg/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_basic_media_ts" */), cache: true },
{ key: "../lang/sg/account/checkout.ts", load: () => import("../lang/sg/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_account_checkout_ts" */), cache: true },
{ key: "../lang/sg/account/checkoutAgainst.ts", load: () => import("../lang/sg/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/sg/account/pay.ts", load: () => import("../lang/sg/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_account_pay_ts" */), cache: true },
{ key: "../lang/sg/support/contactSales.ts", load: () => import("../lang/sg/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_contactSales_ts" */), cache: true },
{ key: "../lang/sg/support/requestTechSupport.ts", load: () => import("../lang/sg/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/sg/support/technicalDocuments.ts", load: () => import("../lang/sg/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/sg/support/mtpDensity.ts", load: () => import("../lang/sg/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/sg/support/picOSVUserGuide.ts", load: () => import("../lang/sg/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/sg/support/fmtSeries.ts", load: () => import("../lang/sg/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/sg/support/SiteMap.ts", load: () => import("../lang/sg/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_SiteMap_ts" */), cache: true },
{ key: "../lang/sg/support/solutionDemoTest.ts", load: () => import("../lang/sg/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/sg/support/queryTools.ts", load: () => import("../lang/sg/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_queryTools_ts" */), cache: true },
{ key: "../lang/sg/support/solutionDemoTest.ts", load: () => import("../lang/sg/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/sg/support/rmaChecklist.ts", load: () => import("../lang/sg/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/sg/support/testSupport.ts", load: () => import("../lang/sg/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_testSupport_ts" */), cache: true },
{ key: "../lang/sg/support/solutionServices.ts", load: () => import("../lang/sg/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_support_solutionServices_ts" */), cache: true },
{ key: "../lang/sg/popup/address.ts", load: () => import("../lang/sg/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_sg_popup_address_ts" */), cache: true }],
  "uk": [{ key: "../lang/uk/common/header.ts", load: () => import("../lang/uk/common/header.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_header_ts" */), cache: true },
{ key: "../lang/uk/common/footer.ts", load: () => import("../lang/uk/common/footer.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_footer_ts" */), cache: true },
{ key: "../lang/uk/common/addCartPopup.ts", load: () => import("../lang/uk/common/addCartPopup.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_addCartPopup_ts" */), cache: true },
{ key: "../lang/uk/common/ContactSales.ts", load: () => import("../lang/uk/common/ContactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_ContactSales_ts" */), cache: true },
{ key: "../lang/uk/common/error.ts", load: () => import("../lang/uk/common/error.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_error_ts" */), cache: true },
{ key: "../lang/uk/common/cookieTip.ts", load: () => import("../lang/uk/common/cookieTip.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_cookieTip_ts" */), cache: true },
{ key: "../lang/uk/common/telCode.ts", load: () => import("../lang/uk/common/telCode.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_telCode_ts" */), cache: true },
{ key: "../lang/uk/common/SelectCountry.ts", load: () => import("../lang/uk/common/SelectCountry.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_SelectCountry_ts" */), cache: true },
{ key: "../lang/uk/common/formValidate.ts", load: () => import("../lang/uk/common/formValidate.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_formValidate_ts" */), cache: true },
{ key: "../lang/uk/common/contactUs.ts", load: () => import("../lang/uk/common/contactUs.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_common_contactUs_ts" */), cache: true },
{ key: "../lang/uk/basic/home.ts", load: () => import("../lang/uk/basic/home.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_home_ts" */), cache: true },
{ key: "../lang/uk/basic/firstCategory.ts", load: () => import("../lang/uk/basic/firstCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_firstCategory_ts" */), cache: true },
{ key: "../lang/uk/basic/secondCategory.ts", load: () => import("../lang/uk/basic/secondCategory.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_secondCategory_ts" */), cache: true },
{ key: "../lang/uk/basic/caseStudy.ts", load: () => import("../lang/uk/basic/caseStudy.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_caseStudy_ts" */), cache: true },
{ key: "../lang/uk/basic/blog.ts", load: () => import("../lang/uk/basic/blog.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_blog_ts" */), cache: true },
{ key: "../lang/uk/basic/media.ts", load: () => import("../lang/uk/basic/media.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_basic_media_ts" */), cache: true },
{ key: "../lang/uk/account/checkout.ts", load: () => import("../lang/uk/account/checkout.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_account_checkout_ts" */), cache: true },
{ key: "../lang/uk/account/checkoutAgainst.ts", load: () => import("../lang/uk/account/checkoutAgainst.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_account_checkoutAgainst_ts" */), cache: true },
{ key: "../lang/uk/account/pay.ts", load: () => import("../lang/uk/account/pay.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_account_pay_ts" */), cache: true },
{ key: "../lang/uk/support/contactSales.ts", load: () => import("../lang/uk/support/contactSales.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_contactSales_ts" */), cache: true },
{ key: "../lang/uk/support/requestTechSupport.ts", load: () => import("../lang/uk/support/requestTechSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_requestTechSupport_ts" */), cache: true },
{ key: "../lang/uk/support/technicalDocuments.ts", load: () => import("../lang/uk/support/technicalDocuments.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_technicalDocuments_ts" */), cache: true },
{ key: "../lang/uk/support/mtpDensity.ts", load: () => import("../lang/uk/support/mtpDensity.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_mtpDensity_ts" */), cache: true },
{ key: "../lang/uk/support/picOSVUserGuide.ts", load: () => import("../lang/uk/support/picOSVUserGuide.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_picOSVUserGuide_ts" */), cache: true },
{ key: "../lang/uk/support/fmtSeries.ts", load: () => import("../lang/uk/support/fmtSeries.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_fmtSeries_ts" */), cache: true },
{ key: "../lang/uk/support/SiteMap.ts", load: () => import("../lang/uk/support/SiteMap.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_SiteMap_ts" */), cache: true },
{ key: "../lang/uk/support/solutionDemoTest.ts", load: () => import("../lang/uk/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/uk/support/queryTools.ts", load: () => import("../lang/uk/support/queryTools.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_queryTools_ts" */), cache: true },
{ key: "../lang/uk/support/solutionDemoTest.ts", load: () => import("../lang/uk/support/solutionDemoTest.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_solutionDemoTest_ts" */), cache: true },
{ key: "../lang/uk/support/rmaChecklist.ts", load: () => import("../lang/uk/support/rmaChecklist.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_rmaChecklist_ts" */), cache: true },
{ key: "../lang/uk/support/testSupport.ts", load: () => import("../lang/uk/support/testSupport.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_testSupport_ts" */), cache: true },
{ key: "../lang/uk/support/solutionServices.ts", load: () => import("../lang/uk/support/solutionServices.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_support_solutionServices_ts" */), cache: true },
{ key: "../lang/uk/popup/address.ts", load: () => import("../lang/uk/popup/address.ts" /* webpackChunkName: "locale__home_jenkins_agent_workspace_platform_static_32front_category_prod_lang_uk_popup_address_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "au",
      "files": [
        "lang/au/common/header.ts",
        "lang/au/common/footer.ts",
        "lang/au/common/addCartPopup.ts",
        "lang/au/common/ContactSales.ts",
        "lang/au/common/error.ts",
        "lang/au/common/cookieTip.ts",
        "lang/au/common/telCode.ts",
        "lang/au/common/SelectCountry.ts",
        "lang/au/common/formValidate.ts",
        "lang/au/common/contactUs.ts",
        "lang/au/basic/home.ts",
        "lang/au/basic/firstCategory.ts",
        "lang/au/basic/secondCategory.ts",
        "lang/au/basic/caseStudy.ts",
        "lang/au/basic/blog.ts",
        "lang/au/basic/media.ts",
        "lang/au/account/checkout.ts",
        "lang/au/account/checkoutAgainst.ts",
        "lang/au/account/pay.ts",
        "lang/au/support/contactSales.ts",
        "lang/au/support/requestTechSupport.ts",
        "lang/au/support/technicalDocuments.ts",
        "lang/au/support/mtpDensity.ts",
        "lang/au/support/picOSVUserGuide.ts",
        "lang/au/support/fmtSeries.ts",
        "lang/au/support/SiteMap.ts",
        "lang/au/support/solutionDemoTest.ts",
        "lang/au/support/queryTools.ts",
        "lang/au/support/solutionDemoTest.ts",
        "lang/au/support/rmaChecklist.ts",
        "lang/au/support/testSupport.ts",
        "lang/au/support/solutionServices.ts",
        "lang/au/popup/address.ts"
      ]
    },
    {
      "code": "de",
      "files": [
        "lang/de/common/header.ts",
        "lang/de/common/footer.ts",
        "lang/de/common/addCartPopup.ts",
        "lang/de/common/ContactSales.ts",
        "lang/de/common/error.ts",
        "lang/de/common/cookieTip.ts",
        "lang/de/common/telCode.ts",
        "lang/de/common/SelectCountry.ts",
        "lang/de/common/formValidate.ts",
        "lang/de/common/contactUs.ts",
        "lang/de/basic/home.ts",
        "lang/de/basic/firstCategory.ts",
        "lang/de/basic/secondCategory.ts",
        "lang/de/basic/caseStudy.ts",
        "lang/de/basic/blog.ts",
        "lang/de/basic/media.ts",
        "lang/de/account/checkout.ts",
        "lang/de/account/checkoutAgainst.ts",
        "lang/de/account/pay.ts",
        "lang/de/support/contactSales.ts",
        "lang/de/support/requestTechSupport.ts",
        "lang/de/support/technicalDocuments.ts",
        "lang/de/support/mtpDensity.ts",
        "lang/de/support/picOSVUserGuide.ts",
        "lang/de/support/fmtSeries.ts",
        "lang/de/support/SiteMap.ts",
        "lang/de/support/solutionDemoTest.ts",
        "lang/de/support/queryTools.ts",
        "lang/de/support/solutionDemoTest.ts",
        "lang/de/support/rmaChecklist.ts",
        "lang/de/support/testSupport.ts",
        "lang/de/support/solutionServices.ts",
        "lang/de/popup/address.ts"
      ]
    },
    {
      "code": "de-en",
      "files": [
        "lang/de-en/common/header.ts",
        "lang/de-en/common/footer.ts",
        "lang/de-en/common/addCartPopup.ts",
        "lang/de-en/common/ContactSales.ts",
        "lang/de-en/common/error.ts",
        "lang/de-en/common/cookieTip.ts",
        "lang/de-en/common/telCode.ts",
        "lang/de-en/common/SelectCountry.ts",
        "lang/de-en/common/formValidate.ts",
        "lang/de-en/common/contactUs.ts",
        "lang/de-en/basic/home.ts",
        "lang/de-en/basic/firstCategory.ts",
        "lang/de-en/basic/secondCategory.ts",
        "lang/de-en/basic/caseStudy.ts",
        "lang/de-en/basic/blog.ts",
        "lang/de-en/basic/media.ts",
        "lang/de-en/account/checkout.ts",
        "lang/de-en/account/checkoutAgainst.ts",
        "lang/de-en/account/pay.ts",
        "lang/de-en/support/contactSales.ts",
        "lang/de-en/support/requestTechSupport.ts",
        "lang/de-en/support/technicalDocuments.ts",
        "lang/de-en/support/mtpDensity.ts",
        "lang/de-en/support/picOSVUserGuide.ts",
        "lang/de-en/support/fmtSeries.ts",
        "lang/de-en/support/SiteMap.ts",
        "lang/de-en/support/solutionDemoTest.ts",
        "lang/de-en/support/queryTools.ts",
        "lang/de-en/support/solutionDemoTest.ts",
        "lang/de-en/support/rmaChecklist.ts",
        "lang/de-en/support/testSupport.ts",
        "lang/de-en/support/solutionServices.ts",
        "lang/de-en/popup/address.ts"
      ]
    },
    {
      "code": "en",
      "files": [
        "lang/en/common/header.ts",
        "lang/en/common/footer.ts",
        "lang/en/common/addCartPopup.ts",
        "lang/en/common/ContactSales.ts",
        "lang/en/common/error.ts",
        "lang/en/common/cookieTip.ts",
        "lang/en/common/telCode.ts",
        "lang/en/common/SelectCountry.ts",
        "lang/en/common/formValidate.ts",
        "lang/en/common/contactUs.ts",
        "lang/en/basic/home.ts",
        "lang/en/basic/firstCategory.ts",
        "lang/en/basic/secondCategory.ts",
        "lang/en/basic/caseStudy.ts",
        "lang/en/basic/blog.ts",
        "lang/en/basic/media.ts",
        "lang/en/account/checkout.ts",
        "lang/en/account/checkoutAgainst.ts",
        "lang/en/account/pay.ts",
        "lang/en/support/contactSales.ts",
        "lang/en/support/requestTechSupport.ts",
        "lang/en/support/technicalDocuments.ts",
        "lang/en/support/mtpDensity.ts",
        "lang/en/support/picOSVUserGuide.ts",
        "lang/en/support/fmtSeries.ts",
        "lang/en/support/SiteMap.ts",
        "lang/en/support/solutionDemoTest.ts",
        "lang/en/support/queryTools.ts",
        "lang/en/support/solutionDemoTest.ts",
        "lang/en/support/rmaChecklist.ts",
        "lang/en/support/testSupport.ts",
        "lang/en/support/solutionServices.ts",
        "lang/en/popup/address.ts"
      ]
    },
    {
      "code": "es",
      "files": [
        "lang/es/common/header.ts",
        "lang/es/common/footer.ts",
        "lang/es/common/addCartPopup.ts",
        "lang/es/common/ContactSales.ts",
        "lang/es/common/error.ts",
        "lang/es/common/cookieTip.ts",
        "lang/es/common/telCode.ts",
        "lang/es/common/SelectCountry.ts",
        "lang/es/common/formValidate.ts",
        "lang/es/common/contactUs.ts",
        "lang/es/basic/home.ts",
        "lang/es/basic/firstCategory.ts",
        "lang/es/basic/secondCategory.ts",
        "lang/es/basic/caseStudy.ts",
        "lang/es/basic/blog.ts",
        "lang/es/basic/media.ts",
        "lang/es/account/checkout.ts",
        "lang/es/account/checkoutAgainst.ts",
        "lang/es/account/pay.ts",
        "lang/es/support/contactSales.ts",
        "lang/es/support/requestTechSupport.ts",
        "lang/es/support/technicalDocuments.ts",
        "lang/es/support/mtpDensity.ts",
        "lang/es/support/picOSVUserGuide.ts",
        "lang/es/support/fmtSeries.ts",
        "lang/es/support/SiteMap.ts",
        "lang/es/support/solutionDemoTest.ts",
        "lang/es/support/queryTools.ts",
        "lang/es/support/solutionDemoTest.ts",
        "lang/es/support/rmaChecklist.ts",
        "lang/es/support/testSupport.ts",
        "lang/es/support/solutionServices.ts",
        "lang/es/popup/address.ts"
      ]
    },
    {
      "code": "mx",
      "files": [
        "lang/es/common/header.ts",
        "lang/es/common/footer.ts",
        "lang/es/common/addCartPopup.ts",
        "lang/es/common/ContactSales.ts",
        "lang/es/common/error.ts",
        "lang/es/common/cookieTip.ts",
        "lang/es/common/telCode.ts",
        "lang/es/common/SelectCountry.ts",
        "lang/es/common/formValidate.ts",
        "lang/es/common/contactUs.ts",
        "lang/es/basic/home.ts",
        "lang/es/basic/firstCategory.ts",
        "lang/es/basic/secondCategory.ts",
        "lang/es/basic/caseStudy.ts",
        "lang/es/basic/blog.ts",
        "lang/es/basic/media.ts",
        "lang/es/account/checkout.ts",
        "lang/es/account/checkoutAgainst.ts",
        "lang/es/account/pay.ts",
        "lang/es/support/contactSales.ts",
        "lang/es/support/requestTechSupport.ts",
        "lang/es/support/technicalDocuments.ts",
        "lang/es/support/mtpDensity.ts",
        "lang/es/support/picOSVUserGuide.ts",
        "lang/es/support/fmtSeries.ts",
        "lang/es/support/SiteMap.ts",
        "lang/es/support/solutionDemoTest.ts",
        "lang/es/support/queryTools.ts",
        "lang/es/support/solutionDemoTest.ts",
        "lang/es/support/rmaChecklist.ts",
        "lang/es/support/testSupport.ts",
        "lang/es/support/solutionServices.ts",
        "lang/es/popup/address.ts"
      ]
    },
    {
      "code": "fr",
      "files": [
        "lang/fr/common/header.ts",
        "lang/fr/common/footer.ts",
        "lang/fr/common/addCartPopup.ts",
        "lang/fr/common/ContactSales.ts",
        "lang/fr/common/error.ts",
        "lang/fr/common/cookieTip.ts",
        "lang/fr/common/telCode.ts",
        "lang/fr/common/SelectCountry.ts",
        "lang/fr/common/formValidate.ts",
        "lang/fr/common/contactUs.ts",
        "lang/fr/basic/home.ts",
        "lang/fr/basic/firstCategory.ts",
        "lang/fr/basic/secondCategory.ts",
        "lang/fr/basic/caseStudy.ts",
        "lang/fr/basic/blog.ts",
        "lang/fr/basic/media.ts",
        "lang/fr/account/checkout.ts",
        "lang/fr/account/checkoutAgainst.ts",
        "lang/fr/account/pay.ts",
        "lang/fr/support/contactSales.ts",
        "lang/fr/support/requestTechSupport.ts",
        "lang/fr/support/technicalDocuments.ts",
        "lang/fr/support/mtpDensity.ts",
        "lang/fr/support/picOSVUserGuide.ts",
        "lang/fr/support/fmtSeries.ts",
        "lang/fr/support/SiteMap.ts",
        "lang/fr/support/solutionDemoTest.ts",
        "lang/fr/support/queryTools.ts",
        "lang/fr/support/solutionDemoTest.ts",
        "lang/fr/support/rmaChecklist.ts",
        "lang/fr/support/testSupport.ts",
        "lang/fr/support/solutionServices.ts",
        "lang/fr/popup/address.ts"
      ]
    },
    {
      "code": "it",
      "files": [
        "lang/it/common/header.ts",
        "lang/it/common/footer.ts",
        "lang/it/common/addCartPopup.ts",
        "lang/it/common/ContactSales.ts",
        "lang/it/common/error.ts",
        "lang/it/common/cookieTip.ts",
        "lang/it/common/telCode.ts",
        "lang/it/common/SelectCountry.ts",
        "lang/it/common/formValidate.ts",
        "lang/it/common/contactUs.ts",
        "lang/it/basic/home.ts",
        "lang/it/basic/firstCategory.ts",
        "lang/it/basic/secondCategory.ts",
        "lang/it/basic/caseStudy.ts",
        "lang/it/basic/blog.ts",
        "lang/it/basic/media.ts",
        "lang/it/account/checkout.ts",
        "lang/it/account/checkoutAgainst.ts",
        "lang/it/account/pay.ts",
        "lang/it/support/contactSales.ts",
        "lang/it/support/requestTechSupport.ts",
        "lang/it/support/technicalDocuments.ts",
        "lang/it/support/mtpDensity.ts",
        "lang/it/support/picOSVUserGuide.ts",
        "lang/it/support/fmtSeries.ts",
        "lang/it/support/SiteMap.ts",
        "lang/it/support/solutionDemoTest.ts",
        "lang/it/support/queryTools.ts",
        "lang/it/support/solutionDemoTest.ts",
        "lang/it/support/rmaChecklist.ts",
        "lang/it/support/testSupport.ts",
        "lang/it/support/solutionServices.ts",
        "lang/it/popup/address.ts"
      ]
    },
    {
      "code": "jp",
      "files": [
        "lang/jp/common/header.ts",
        "lang/jp/common/footer.ts",
        "lang/jp/common/addCartPopup.ts",
        "lang/jp/common/ContactSales.ts",
        "lang/jp/common/error.ts",
        "lang/jp/common/cookieTip.ts",
        "lang/jp/common/telCode.ts",
        "lang/jp/common/SelectCountry.ts",
        "lang/jp/common/formValidate.ts",
        "lang/jp/common/contactUs.ts",
        "lang/jp/basic/home.ts",
        "lang/jp/basic/firstCategory.ts",
        "lang/jp/basic/secondCategory.ts",
        "lang/jp/basic/caseStudy.ts",
        "lang/jp/basic/blog.ts",
        "lang/jp/basic/media.ts",
        "lang/jp/account/checkout.ts",
        "lang/jp/account/checkoutAgainst.ts",
        "lang/jp/account/pay.ts",
        "lang/jp/support/contactSales.ts",
        "lang/jp/support/requestTechSupport.ts",
        "lang/jp/support/technicalDocuments.ts",
        "lang/jp/support/mtpDensity.ts",
        "lang/jp/support/picOSVUserGuide.ts",
        "lang/jp/support/fmtSeries.ts",
        "lang/jp/support/SiteMap.ts",
        "lang/jp/support/solutionDemoTest.ts",
        "lang/jp/support/queryTools.ts",
        "lang/jp/support/solutionDemoTest.ts",
        "lang/jp/support/rmaChecklist.ts",
        "lang/jp/support/testSupport.ts",
        "lang/jp/support/solutionServices.ts",
        "lang/jp/popup/address.ts"
      ]
    },
    {
      "code": "ru",
      "files": [
        "lang/ru/common/header.ts",
        "lang/ru/common/footer.ts",
        "lang/ru/common/addCartPopup.ts",
        "lang/ru/common/ContactSales.ts",
        "lang/ru/common/error.ts",
        "lang/ru/common/cookieTip.ts",
        "lang/ru/common/telCode.ts",
        "lang/ru/common/SelectCountry.ts",
        "lang/ru/common/formValidate.ts",
        "lang/ru/common/contactUs.ts",
        "lang/ru/basic/home.ts",
        "lang/ru/basic/firstCategory.ts",
        "lang/ru/basic/secondCategory.ts",
        "lang/ru/basic/caseStudy.ts",
        "lang/ru/basic/blog.ts",
        "lang/ru/basic/media.ts",
        "lang/ru/account/checkout.ts",
        "lang/ru/account/checkoutAgainst.ts",
        "lang/ru/account/pay.ts",
        "lang/ru/support/contactSales.ts",
        "lang/ru/support/requestTechSupport.ts",
        "lang/ru/support/technicalDocuments.ts",
        "lang/ru/support/mtpDensity.ts",
        "lang/ru/support/picOSVUserGuide.ts",
        "lang/ru/support/fmtSeries.ts",
        "lang/ru/support/SiteMap.ts",
        "lang/ru/support/solutionDemoTest.ts",
        "lang/ru/support/queryTools.ts",
        "lang/ru/support/solutionDemoTest.ts",
        "lang/ru/support/rmaChecklist.ts",
        "lang/ru/support/testSupport.ts",
        "lang/ru/support/solutionServices.ts",
        "lang/ru/popup/address.ts"
      ]
    },
    {
      "code": "sg",
      "files": [
        "lang/sg/common/header.ts",
        "lang/sg/common/footer.ts",
        "lang/sg/common/addCartPopup.ts",
        "lang/sg/common/ContactSales.ts",
        "lang/sg/common/error.ts",
        "lang/sg/common/cookieTip.ts",
        "lang/sg/common/telCode.ts",
        "lang/sg/common/SelectCountry.ts",
        "lang/sg/common/formValidate.ts",
        "lang/sg/common/contactUs.ts",
        "lang/sg/basic/home.ts",
        "lang/sg/basic/firstCategory.ts",
        "lang/sg/basic/secondCategory.ts",
        "lang/sg/basic/caseStudy.ts",
        "lang/sg/basic/blog.ts",
        "lang/sg/basic/media.ts",
        "lang/sg/account/checkout.ts",
        "lang/sg/account/checkoutAgainst.ts",
        "lang/sg/account/pay.ts",
        "lang/sg/support/contactSales.ts",
        "lang/sg/support/requestTechSupport.ts",
        "lang/sg/support/technicalDocuments.ts",
        "lang/sg/support/mtpDensity.ts",
        "lang/sg/support/picOSVUserGuide.ts",
        "lang/sg/support/fmtSeries.ts",
        "lang/sg/support/SiteMap.ts",
        "lang/sg/support/solutionDemoTest.ts",
        "lang/sg/support/queryTools.ts",
        "lang/sg/support/solutionDemoTest.ts",
        "lang/sg/support/rmaChecklist.ts",
        "lang/sg/support/testSupport.ts",
        "lang/sg/support/solutionServices.ts",
        "lang/sg/popup/address.ts"
      ]
    },
    {
      "code": "uk",
      "files": [
        "lang/uk/common/header.ts",
        "lang/uk/common/footer.ts",
        "lang/uk/common/addCartPopup.ts",
        "lang/uk/common/ContactSales.ts",
        "lang/uk/common/error.ts",
        "lang/uk/common/cookieTip.ts",
        "lang/uk/common/telCode.ts",
        "lang/uk/common/SelectCountry.ts",
        "lang/uk/common/formValidate.ts",
        "lang/uk/common/contactUs.ts",
        "lang/uk/basic/home.ts",
        "lang/uk/basic/firstCategory.ts",
        "lang/uk/basic/secondCategory.ts",
        "lang/uk/basic/caseStudy.ts",
        "lang/uk/basic/blog.ts",
        "lang/uk/basic/media.ts",
        "lang/uk/account/checkout.ts",
        "lang/uk/account/checkoutAgainst.ts",
        "lang/uk/account/pay.ts",
        "lang/uk/support/contactSales.ts",
        "lang/uk/support/requestTechSupport.ts",
        "lang/uk/support/technicalDocuments.ts",
        "lang/uk/support/mtpDensity.ts",
        "lang/uk/support/picOSVUserGuide.ts",
        "lang/uk/support/fmtSeries.ts",
        "lang/uk/support/SiteMap.ts",
        "lang/uk/support/solutionDemoTest.ts",
        "lang/uk/support/queryTools.ts",
        "lang/uk/support/solutionDemoTest.ts",
        "lang/uk/support/rmaChecklist.ts",
        "lang/uk/support/testSupport.ts",
        "lang/uk/support/solutionServices.ts",
        "lang/uk/popup/address.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "au",
    "files": [
      {
        "path": "lang/au/common/header.ts"
      },
      {
        "path": "lang/au/common/footer.ts"
      },
      {
        "path": "lang/au/common/addCartPopup.ts"
      },
      {
        "path": "lang/au/common/ContactSales.ts"
      },
      {
        "path": "lang/au/common/error.ts"
      },
      {
        "path": "lang/au/common/cookieTip.ts"
      },
      {
        "path": "lang/au/common/telCode.ts"
      },
      {
        "path": "lang/au/common/SelectCountry.ts"
      },
      {
        "path": "lang/au/common/formValidate.ts"
      },
      {
        "path": "lang/au/common/contactUs.ts"
      },
      {
        "path": "lang/au/basic/home.ts"
      },
      {
        "path": "lang/au/basic/firstCategory.ts"
      },
      {
        "path": "lang/au/basic/secondCategory.ts"
      },
      {
        "path": "lang/au/basic/caseStudy.ts"
      },
      {
        "path": "lang/au/basic/blog.ts"
      },
      {
        "path": "lang/au/basic/media.ts"
      },
      {
        "path": "lang/au/account/checkout.ts"
      },
      {
        "path": "lang/au/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/au/account/pay.ts"
      },
      {
        "path": "lang/au/support/contactSales.ts"
      },
      {
        "path": "lang/au/support/requestTechSupport.ts"
      },
      {
        "path": "lang/au/support/technicalDocuments.ts"
      },
      {
        "path": "lang/au/support/mtpDensity.ts"
      },
      {
        "path": "lang/au/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/au/support/fmtSeries.ts"
      },
      {
        "path": "lang/au/support/SiteMap.ts"
      },
      {
        "path": "lang/au/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/au/support/queryTools.ts"
      },
      {
        "path": "lang/au/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/au/support/rmaChecklist.ts"
      },
      {
        "path": "lang/au/support/testSupport.ts"
      },
      {
        "path": "lang/au/support/solutionServices.ts"
      },
      {
        "path": "lang/au/popup/address.ts"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "lang/de/common/header.ts"
      },
      {
        "path": "lang/de/common/footer.ts"
      },
      {
        "path": "lang/de/common/addCartPopup.ts"
      },
      {
        "path": "lang/de/common/ContactSales.ts"
      },
      {
        "path": "lang/de/common/error.ts"
      },
      {
        "path": "lang/de/common/cookieTip.ts"
      },
      {
        "path": "lang/de/common/telCode.ts"
      },
      {
        "path": "lang/de/common/SelectCountry.ts"
      },
      {
        "path": "lang/de/common/formValidate.ts"
      },
      {
        "path": "lang/de/common/contactUs.ts"
      },
      {
        "path": "lang/de/basic/home.ts"
      },
      {
        "path": "lang/de/basic/firstCategory.ts"
      },
      {
        "path": "lang/de/basic/secondCategory.ts"
      },
      {
        "path": "lang/de/basic/caseStudy.ts"
      },
      {
        "path": "lang/de/basic/blog.ts"
      },
      {
        "path": "lang/de/basic/media.ts"
      },
      {
        "path": "lang/de/account/checkout.ts"
      },
      {
        "path": "lang/de/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/de/account/pay.ts"
      },
      {
        "path": "lang/de/support/contactSales.ts"
      },
      {
        "path": "lang/de/support/requestTechSupport.ts"
      },
      {
        "path": "lang/de/support/technicalDocuments.ts"
      },
      {
        "path": "lang/de/support/mtpDensity.ts"
      },
      {
        "path": "lang/de/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/de/support/fmtSeries.ts"
      },
      {
        "path": "lang/de/support/SiteMap.ts"
      },
      {
        "path": "lang/de/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/de/support/queryTools.ts"
      },
      {
        "path": "lang/de/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/de/support/rmaChecklist.ts"
      },
      {
        "path": "lang/de/support/testSupport.ts"
      },
      {
        "path": "lang/de/support/solutionServices.ts"
      },
      {
        "path": "lang/de/popup/address.ts"
      }
    ]
  },
  {
    "code": "de-en",
    "files": [
      {
        "path": "lang/de-en/common/header.ts"
      },
      {
        "path": "lang/de-en/common/footer.ts"
      },
      {
        "path": "lang/de-en/common/addCartPopup.ts"
      },
      {
        "path": "lang/de-en/common/ContactSales.ts"
      },
      {
        "path": "lang/de-en/common/error.ts"
      },
      {
        "path": "lang/de-en/common/cookieTip.ts"
      },
      {
        "path": "lang/de-en/common/telCode.ts"
      },
      {
        "path": "lang/de-en/common/SelectCountry.ts"
      },
      {
        "path": "lang/de-en/common/formValidate.ts"
      },
      {
        "path": "lang/de-en/common/contactUs.ts"
      },
      {
        "path": "lang/de-en/basic/home.ts"
      },
      {
        "path": "lang/de-en/basic/firstCategory.ts"
      },
      {
        "path": "lang/de-en/basic/secondCategory.ts"
      },
      {
        "path": "lang/de-en/basic/caseStudy.ts"
      },
      {
        "path": "lang/de-en/basic/blog.ts"
      },
      {
        "path": "lang/de-en/basic/media.ts"
      },
      {
        "path": "lang/de-en/account/checkout.ts"
      },
      {
        "path": "lang/de-en/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/de-en/account/pay.ts"
      },
      {
        "path": "lang/de-en/support/contactSales.ts"
      },
      {
        "path": "lang/de-en/support/requestTechSupport.ts"
      },
      {
        "path": "lang/de-en/support/technicalDocuments.ts"
      },
      {
        "path": "lang/de-en/support/mtpDensity.ts"
      },
      {
        "path": "lang/de-en/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/de-en/support/fmtSeries.ts"
      },
      {
        "path": "lang/de-en/support/SiteMap.ts"
      },
      {
        "path": "lang/de-en/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/de-en/support/queryTools.ts"
      },
      {
        "path": "lang/de-en/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/de-en/support/rmaChecklist.ts"
      },
      {
        "path": "lang/de-en/support/testSupport.ts"
      },
      {
        "path": "lang/de-en/support/solutionServices.ts"
      },
      {
        "path": "lang/de-en/popup/address.ts"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "lang/en/common/header.ts"
      },
      {
        "path": "lang/en/common/footer.ts"
      },
      {
        "path": "lang/en/common/addCartPopup.ts"
      },
      {
        "path": "lang/en/common/ContactSales.ts"
      },
      {
        "path": "lang/en/common/error.ts"
      },
      {
        "path": "lang/en/common/cookieTip.ts"
      },
      {
        "path": "lang/en/common/telCode.ts"
      },
      {
        "path": "lang/en/common/SelectCountry.ts"
      },
      {
        "path": "lang/en/common/formValidate.ts"
      },
      {
        "path": "lang/en/common/contactUs.ts"
      },
      {
        "path": "lang/en/basic/home.ts"
      },
      {
        "path": "lang/en/basic/firstCategory.ts"
      },
      {
        "path": "lang/en/basic/secondCategory.ts"
      },
      {
        "path": "lang/en/basic/caseStudy.ts"
      },
      {
        "path": "lang/en/basic/blog.ts"
      },
      {
        "path": "lang/en/basic/media.ts"
      },
      {
        "path": "lang/en/account/checkout.ts"
      },
      {
        "path": "lang/en/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/en/account/pay.ts"
      },
      {
        "path": "lang/en/support/contactSales.ts"
      },
      {
        "path": "lang/en/support/requestTechSupport.ts"
      },
      {
        "path": "lang/en/support/technicalDocuments.ts"
      },
      {
        "path": "lang/en/support/mtpDensity.ts"
      },
      {
        "path": "lang/en/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/en/support/fmtSeries.ts"
      },
      {
        "path": "lang/en/support/SiteMap.ts"
      },
      {
        "path": "lang/en/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/en/support/queryTools.ts"
      },
      {
        "path": "lang/en/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/en/support/rmaChecklist.ts"
      },
      {
        "path": "lang/en/support/testSupport.ts"
      },
      {
        "path": "lang/en/support/solutionServices.ts"
      },
      {
        "path": "lang/en/popup/address.ts"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "lang/es/common/header.ts"
      },
      {
        "path": "lang/es/common/footer.ts"
      },
      {
        "path": "lang/es/common/addCartPopup.ts"
      },
      {
        "path": "lang/es/common/ContactSales.ts"
      },
      {
        "path": "lang/es/common/error.ts"
      },
      {
        "path": "lang/es/common/cookieTip.ts"
      },
      {
        "path": "lang/es/common/telCode.ts"
      },
      {
        "path": "lang/es/common/SelectCountry.ts"
      },
      {
        "path": "lang/es/common/formValidate.ts"
      },
      {
        "path": "lang/es/common/contactUs.ts"
      },
      {
        "path": "lang/es/basic/home.ts"
      },
      {
        "path": "lang/es/basic/firstCategory.ts"
      },
      {
        "path": "lang/es/basic/secondCategory.ts"
      },
      {
        "path": "lang/es/basic/caseStudy.ts"
      },
      {
        "path": "lang/es/basic/blog.ts"
      },
      {
        "path": "lang/es/basic/media.ts"
      },
      {
        "path": "lang/es/account/checkout.ts"
      },
      {
        "path": "lang/es/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/es/account/pay.ts"
      },
      {
        "path": "lang/es/support/contactSales.ts"
      },
      {
        "path": "lang/es/support/requestTechSupport.ts"
      },
      {
        "path": "lang/es/support/technicalDocuments.ts"
      },
      {
        "path": "lang/es/support/mtpDensity.ts"
      },
      {
        "path": "lang/es/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/es/support/fmtSeries.ts"
      },
      {
        "path": "lang/es/support/SiteMap.ts"
      },
      {
        "path": "lang/es/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/es/support/queryTools.ts"
      },
      {
        "path": "lang/es/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/es/support/rmaChecklist.ts"
      },
      {
        "path": "lang/es/support/testSupport.ts"
      },
      {
        "path": "lang/es/support/solutionServices.ts"
      },
      {
        "path": "lang/es/popup/address.ts"
      }
    ]
  },
  {
    "code": "mx",
    "files": [
      {
        "path": "lang/es/common/header.ts"
      },
      {
        "path": "lang/es/common/footer.ts"
      },
      {
        "path": "lang/es/common/addCartPopup.ts"
      },
      {
        "path": "lang/es/common/ContactSales.ts"
      },
      {
        "path": "lang/es/common/error.ts"
      },
      {
        "path": "lang/es/common/cookieTip.ts"
      },
      {
        "path": "lang/es/common/telCode.ts"
      },
      {
        "path": "lang/es/common/SelectCountry.ts"
      },
      {
        "path": "lang/es/common/formValidate.ts"
      },
      {
        "path": "lang/es/common/contactUs.ts"
      },
      {
        "path": "lang/es/basic/home.ts"
      },
      {
        "path": "lang/es/basic/firstCategory.ts"
      },
      {
        "path": "lang/es/basic/secondCategory.ts"
      },
      {
        "path": "lang/es/basic/caseStudy.ts"
      },
      {
        "path": "lang/es/basic/blog.ts"
      },
      {
        "path": "lang/es/basic/media.ts"
      },
      {
        "path": "lang/es/account/checkout.ts"
      },
      {
        "path": "lang/es/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/es/account/pay.ts"
      },
      {
        "path": "lang/es/support/contactSales.ts"
      },
      {
        "path": "lang/es/support/requestTechSupport.ts"
      },
      {
        "path": "lang/es/support/technicalDocuments.ts"
      },
      {
        "path": "lang/es/support/mtpDensity.ts"
      },
      {
        "path": "lang/es/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/es/support/fmtSeries.ts"
      },
      {
        "path": "lang/es/support/SiteMap.ts"
      },
      {
        "path": "lang/es/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/es/support/queryTools.ts"
      },
      {
        "path": "lang/es/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/es/support/rmaChecklist.ts"
      },
      {
        "path": "lang/es/support/testSupport.ts"
      },
      {
        "path": "lang/es/support/solutionServices.ts"
      },
      {
        "path": "lang/es/popup/address.ts"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "lang/fr/common/header.ts"
      },
      {
        "path": "lang/fr/common/footer.ts"
      },
      {
        "path": "lang/fr/common/addCartPopup.ts"
      },
      {
        "path": "lang/fr/common/ContactSales.ts"
      },
      {
        "path": "lang/fr/common/error.ts"
      },
      {
        "path": "lang/fr/common/cookieTip.ts"
      },
      {
        "path": "lang/fr/common/telCode.ts"
      },
      {
        "path": "lang/fr/common/SelectCountry.ts"
      },
      {
        "path": "lang/fr/common/formValidate.ts"
      },
      {
        "path": "lang/fr/common/contactUs.ts"
      },
      {
        "path": "lang/fr/basic/home.ts"
      },
      {
        "path": "lang/fr/basic/firstCategory.ts"
      },
      {
        "path": "lang/fr/basic/secondCategory.ts"
      },
      {
        "path": "lang/fr/basic/caseStudy.ts"
      },
      {
        "path": "lang/fr/basic/blog.ts"
      },
      {
        "path": "lang/fr/basic/media.ts"
      },
      {
        "path": "lang/fr/account/checkout.ts"
      },
      {
        "path": "lang/fr/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/fr/account/pay.ts"
      },
      {
        "path": "lang/fr/support/contactSales.ts"
      },
      {
        "path": "lang/fr/support/requestTechSupport.ts"
      },
      {
        "path": "lang/fr/support/technicalDocuments.ts"
      },
      {
        "path": "lang/fr/support/mtpDensity.ts"
      },
      {
        "path": "lang/fr/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/fr/support/fmtSeries.ts"
      },
      {
        "path": "lang/fr/support/SiteMap.ts"
      },
      {
        "path": "lang/fr/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/fr/support/queryTools.ts"
      },
      {
        "path": "lang/fr/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/fr/support/rmaChecklist.ts"
      },
      {
        "path": "lang/fr/support/testSupport.ts"
      },
      {
        "path": "lang/fr/support/solutionServices.ts"
      },
      {
        "path": "lang/fr/popup/address.ts"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "lang/it/common/header.ts"
      },
      {
        "path": "lang/it/common/footer.ts"
      },
      {
        "path": "lang/it/common/addCartPopup.ts"
      },
      {
        "path": "lang/it/common/ContactSales.ts"
      },
      {
        "path": "lang/it/common/error.ts"
      },
      {
        "path": "lang/it/common/cookieTip.ts"
      },
      {
        "path": "lang/it/common/telCode.ts"
      },
      {
        "path": "lang/it/common/SelectCountry.ts"
      },
      {
        "path": "lang/it/common/formValidate.ts"
      },
      {
        "path": "lang/it/common/contactUs.ts"
      },
      {
        "path": "lang/it/basic/home.ts"
      },
      {
        "path": "lang/it/basic/firstCategory.ts"
      },
      {
        "path": "lang/it/basic/secondCategory.ts"
      },
      {
        "path": "lang/it/basic/caseStudy.ts"
      },
      {
        "path": "lang/it/basic/blog.ts"
      },
      {
        "path": "lang/it/basic/media.ts"
      },
      {
        "path": "lang/it/account/checkout.ts"
      },
      {
        "path": "lang/it/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/it/account/pay.ts"
      },
      {
        "path": "lang/it/support/contactSales.ts"
      },
      {
        "path": "lang/it/support/requestTechSupport.ts"
      },
      {
        "path": "lang/it/support/technicalDocuments.ts"
      },
      {
        "path": "lang/it/support/mtpDensity.ts"
      },
      {
        "path": "lang/it/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/it/support/fmtSeries.ts"
      },
      {
        "path": "lang/it/support/SiteMap.ts"
      },
      {
        "path": "lang/it/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/it/support/queryTools.ts"
      },
      {
        "path": "lang/it/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/it/support/rmaChecklist.ts"
      },
      {
        "path": "lang/it/support/testSupport.ts"
      },
      {
        "path": "lang/it/support/solutionServices.ts"
      },
      {
        "path": "lang/it/popup/address.ts"
      }
    ]
  },
  {
    "code": "jp",
    "files": [
      {
        "path": "lang/jp/common/header.ts"
      },
      {
        "path": "lang/jp/common/footer.ts"
      },
      {
        "path": "lang/jp/common/addCartPopup.ts"
      },
      {
        "path": "lang/jp/common/ContactSales.ts"
      },
      {
        "path": "lang/jp/common/error.ts"
      },
      {
        "path": "lang/jp/common/cookieTip.ts"
      },
      {
        "path": "lang/jp/common/telCode.ts"
      },
      {
        "path": "lang/jp/common/SelectCountry.ts"
      },
      {
        "path": "lang/jp/common/formValidate.ts"
      },
      {
        "path": "lang/jp/common/contactUs.ts"
      },
      {
        "path": "lang/jp/basic/home.ts"
      },
      {
        "path": "lang/jp/basic/firstCategory.ts"
      },
      {
        "path": "lang/jp/basic/secondCategory.ts"
      },
      {
        "path": "lang/jp/basic/caseStudy.ts"
      },
      {
        "path": "lang/jp/basic/blog.ts"
      },
      {
        "path": "lang/jp/basic/media.ts"
      },
      {
        "path": "lang/jp/account/checkout.ts"
      },
      {
        "path": "lang/jp/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/jp/account/pay.ts"
      },
      {
        "path": "lang/jp/support/contactSales.ts"
      },
      {
        "path": "lang/jp/support/requestTechSupport.ts"
      },
      {
        "path": "lang/jp/support/technicalDocuments.ts"
      },
      {
        "path": "lang/jp/support/mtpDensity.ts"
      },
      {
        "path": "lang/jp/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/jp/support/fmtSeries.ts"
      },
      {
        "path": "lang/jp/support/SiteMap.ts"
      },
      {
        "path": "lang/jp/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/jp/support/queryTools.ts"
      },
      {
        "path": "lang/jp/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/jp/support/rmaChecklist.ts"
      },
      {
        "path": "lang/jp/support/testSupport.ts"
      },
      {
        "path": "lang/jp/support/solutionServices.ts"
      },
      {
        "path": "lang/jp/popup/address.ts"
      }
    ]
  },
  {
    "code": "ru",
    "files": [
      {
        "path": "lang/ru/common/header.ts"
      },
      {
        "path": "lang/ru/common/footer.ts"
      },
      {
        "path": "lang/ru/common/addCartPopup.ts"
      },
      {
        "path": "lang/ru/common/ContactSales.ts"
      },
      {
        "path": "lang/ru/common/error.ts"
      },
      {
        "path": "lang/ru/common/cookieTip.ts"
      },
      {
        "path": "lang/ru/common/telCode.ts"
      },
      {
        "path": "lang/ru/common/SelectCountry.ts"
      },
      {
        "path": "lang/ru/common/formValidate.ts"
      },
      {
        "path": "lang/ru/common/contactUs.ts"
      },
      {
        "path": "lang/ru/basic/home.ts"
      },
      {
        "path": "lang/ru/basic/firstCategory.ts"
      },
      {
        "path": "lang/ru/basic/secondCategory.ts"
      },
      {
        "path": "lang/ru/basic/caseStudy.ts"
      },
      {
        "path": "lang/ru/basic/blog.ts"
      },
      {
        "path": "lang/ru/basic/media.ts"
      },
      {
        "path": "lang/ru/account/checkout.ts"
      },
      {
        "path": "lang/ru/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/ru/account/pay.ts"
      },
      {
        "path": "lang/ru/support/contactSales.ts"
      },
      {
        "path": "lang/ru/support/requestTechSupport.ts"
      },
      {
        "path": "lang/ru/support/technicalDocuments.ts"
      },
      {
        "path": "lang/ru/support/mtpDensity.ts"
      },
      {
        "path": "lang/ru/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/ru/support/fmtSeries.ts"
      },
      {
        "path": "lang/ru/support/SiteMap.ts"
      },
      {
        "path": "lang/ru/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/ru/support/queryTools.ts"
      },
      {
        "path": "lang/ru/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/ru/support/rmaChecklist.ts"
      },
      {
        "path": "lang/ru/support/testSupport.ts"
      },
      {
        "path": "lang/ru/support/solutionServices.ts"
      },
      {
        "path": "lang/ru/popup/address.ts"
      }
    ]
  },
  {
    "code": "sg",
    "files": [
      {
        "path": "lang/sg/common/header.ts"
      },
      {
        "path": "lang/sg/common/footer.ts"
      },
      {
        "path": "lang/sg/common/addCartPopup.ts"
      },
      {
        "path": "lang/sg/common/ContactSales.ts"
      },
      {
        "path": "lang/sg/common/error.ts"
      },
      {
        "path": "lang/sg/common/cookieTip.ts"
      },
      {
        "path": "lang/sg/common/telCode.ts"
      },
      {
        "path": "lang/sg/common/SelectCountry.ts"
      },
      {
        "path": "lang/sg/common/formValidate.ts"
      },
      {
        "path": "lang/sg/common/contactUs.ts"
      },
      {
        "path": "lang/sg/basic/home.ts"
      },
      {
        "path": "lang/sg/basic/firstCategory.ts"
      },
      {
        "path": "lang/sg/basic/secondCategory.ts"
      },
      {
        "path": "lang/sg/basic/caseStudy.ts"
      },
      {
        "path": "lang/sg/basic/blog.ts"
      },
      {
        "path": "lang/sg/basic/media.ts"
      },
      {
        "path": "lang/sg/account/checkout.ts"
      },
      {
        "path": "lang/sg/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/sg/account/pay.ts"
      },
      {
        "path": "lang/sg/support/contactSales.ts"
      },
      {
        "path": "lang/sg/support/requestTechSupport.ts"
      },
      {
        "path": "lang/sg/support/technicalDocuments.ts"
      },
      {
        "path": "lang/sg/support/mtpDensity.ts"
      },
      {
        "path": "lang/sg/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/sg/support/fmtSeries.ts"
      },
      {
        "path": "lang/sg/support/SiteMap.ts"
      },
      {
        "path": "lang/sg/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/sg/support/queryTools.ts"
      },
      {
        "path": "lang/sg/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/sg/support/rmaChecklist.ts"
      },
      {
        "path": "lang/sg/support/testSupport.ts"
      },
      {
        "path": "lang/sg/support/solutionServices.ts"
      },
      {
        "path": "lang/sg/popup/address.ts"
      }
    ]
  },
  {
    "code": "uk",
    "files": [
      {
        "path": "lang/uk/common/header.ts"
      },
      {
        "path": "lang/uk/common/footer.ts"
      },
      {
        "path": "lang/uk/common/addCartPopup.ts"
      },
      {
        "path": "lang/uk/common/ContactSales.ts"
      },
      {
        "path": "lang/uk/common/error.ts"
      },
      {
        "path": "lang/uk/common/cookieTip.ts"
      },
      {
        "path": "lang/uk/common/telCode.ts"
      },
      {
        "path": "lang/uk/common/SelectCountry.ts"
      },
      {
        "path": "lang/uk/common/formValidate.ts"
      },
      {
        "path": "lang/uk/common/contactUs.ts"
      },
      {
        "path": "lang/uk/basic/home.ts"
      },
      {
        "path": "lang/uk/basic/firstCategory.ts"
      },
      {
        "path": "lang/uk/basic/secondCategory.ts"
      },
      {
        "path": "lang/uk/basic/caseStudy.ts"
      },
      {
        "path": "lang/uk/basic/blog.ts"
      },
      {
        "path": "lang/uk/basic/media.ts"
      },
      {
        "path": "lang/uk/account/checkout.ts"
      },
      {
        "path": "lang/uk/account/checkoutAgainst.ts"
      },
      {
        "path": "lang/uk/account/pay.ts"
      },
      {
        "path": "lang/uk/support/contactSales.ts"
      },
      {
        "path": "lang/uk/support/requestTechSupport.ts"
      },
      {
        "path": "lang/uk/support/technicalDocuments.ts"
      },
      {
        "path": "lang/uk/support/mtpDensity.ts"
      },
      {
        "path": "lang/uk/support/picOSVUserGuide.ts"
      },
      {
        "path": "lang/uk/support/fmtSeries.ts"
      },
      {
        "path": "lang/uk/support/SiteMap.ts"
      },
      {
        "path": "lang/uk/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/uk/support/queryTools.ts"
      },
      {
        "path": "lang/uk/support/solutionDemoTest.ts"
      },
      {
        "path": "lang/uk/support/rmaChecklist.ts"
      },
      {
        "path": "lang/uk/support/testSupport.ts"
      },
      {
        "path": "lang/uk/support/solutionServices.ts"
      },
      {
        "path": "lang/uk/popup/address.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
